if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.home-slider-js').slick({
        accessibility: false
    });


    $(".home-slider__arrows .slick-prev").click(function(){
        $(".home-slider-js").slick("slickPrev");
    });
    $(".home-slider__arrows .slick-next").click(function(){
        $(".home-slider-js").slick("slickNext");
    });


    //tabs content
    document.querySelectorAll('.tab-js li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.tab-js li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            activeContentItem(btn.dataset.tag);
        });

        if (i === 0) btn.click();
    });
    function activeContentItem(tag){
        document.querySelectorAll('.tab-item-js').forEach( item => {
            item.classList.remove('active');
            if ( tag === 'all' || tag === item.dataset.tag ) {

                let data_tag =item.getAttribute('data-tag');
                item.classList.add('active');

                if(page_id == '71207'){
                    let ul = item.childNodes[3].childNodes[1].childNodes[1];
                    let dataTagChild =  ul.getAttribute('data-tag');
                    if(data_tag != dataTagChild ){
                        ul.nextElementSibling.classList.add('active');
                    }
                    else{
                        ul.classList.add('active');
                    }
                }
            }


        }); 
    }
    
})();